"use client";

import { c as _c } from "react/compiler-runtime";
import { ChevronsUpDown, Check, Sparkles, Building2 } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useSidebar } from "@/components/ui/sidebar";
import { useI18n } from "@llmgateway/i18n/react";
import type { Organization } from "@/lib/types";
interface OrganizationSwitcherProps {
  organizations: Organization[];
  selectedOrganization: Organization | null;
  onSelectOrganization: (org: Organization | null) => void;
}
export function OrganizationSwitcher(t0) {
  const $ = _c(65);
  const {
    organizations,
    selectedOrganization,
    onSelectOrganization
  } = t0;
  const {
    t
  } = useI18n();
  const [mounted, setMounted] = useState(false);
  const {
    isMobile,
    setOpenMobile
  } = useSidebar();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMounted(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== isMobile || $[3] !== onSelectOrganization || $[4] !== setOpenMobile) {
    t3 = org => {
      if (isMobile) {
        setOpenMobile(false);
      }
      onSelectOrganization(org);
    };
    $[2] = isMobile;
    $[3] = onSelectOrganization;
    $[4] = setOpenMobile;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleSelectOrganization = t3;
  const isChatPlanContext = !selectedOrganization || selectedOrganization.isChat;
  const activeClass = isChatPlanContext ? "" : "bg-accent text-accent-foreground";
  if (!mounted) {
    const t4 = `flex w-full min-w-0 items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium text-foreground hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background justify-start ${activeClass}`;
    let t5;
    if ($[6] !== isChatPlanContext) {
      t5 = isChatPlanContext ? <Sparkles className="h-4 w-4 flex-shrink-0 text-muted-foreground" /> : <Building2 className="h-4 w-4 flex-shrink-0 text-muted-foreground" />;
      $[6] = isChatPlanContext;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    let t6;
    if ($[8] !== isChatPlanContext || $[9] !== selectedOrganization || $[10] !== t) {
      t6 = isChatPlanContext ? t("entities.chatPlan") : selectedOrganization.name;
      $[8] = isChatPlanContext;
      $[9] = selectedOrganization;
      $[10] = t;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== t6) {
      t7 = <span className="truncate">{t6}</span>;
      $[12] = t6;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    let t8;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <ChevronsUpDown className="ml-auto h-4 w-4 flex-shrink-0 opacity-50" />;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    let t9;
    if ($[15] !== t4 || $[16] !== t5 || $[17] !== t7) {
      t9 = <Button variant="ghost" disabled={true} className={t4}>{t5}{t7}{t8}</Button>;
      $[15] = t4;
      $[16] = t5;
      $[17] = t7;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    return t9;
  }
  const t4 = `flex w-full min-w-0 items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium text-foreground hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background justify-start ${activeClass}`;
  let t5;
  if ($[19] !== isChatPlanContext) {
    t5 = isChatPlanContext ? <Sparkles className="h-4 w-4 flex-shrink-0 text-muted-foreground" /> : <Building2 className="h-4 w-4 flex-shrink-0 text-muted-foreground" />;
    $[19] = isChatPlanContext;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== isChatPlanContext || $[22] !== selectedOrganization || $[23] !== t) {
    t6 = isChatPlanContext ? t("entities.chatPlan") : selectedOrganization.name;
    $[21] = isChatPlanContext;
    $[22] = selectedOrganization;
    $[23] = t;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== t6) {
    t7 = <span className="truncate">{t6}</span>;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ChevronsUpDown className="ml-auto h-4 w-4 flex-shrink-0 opacity-50" />;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t4 || $[29] !== t5 || $[30] !== t7) {
    t9 = <DropdownMenuTrigger asChild={true}><Button variant="ghost" className={t4}>{t5}{t7}{t8}</Button></DropdownMenuTrigger>;
    $[28] = t4;
    $[29] = t5;
    $[30] = t7;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== handleSelectOrganization) {
    t10 = () => handleSelectOrganization(null);
    $[32] = handleSelectOrganization;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Sparkles className="mr-2 h-4 w-4 flex-shrink-0 text-muted-foreground" />;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== t) {
    t12 = t("entities.chatPlan");
    $[35] = t;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== t12) {
    t13 = <span className="truncate">{t12}</span>;
    $[37] = t12;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== isChatPlanContext) {
    t14 = isChatPlanContext ? <Check className="ml-auto h-4 w-4 flex-shrink-0" /> : null;
    $[39] = isChatPlanContext;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== t10 || $[42] !== t13 || $[43] !== t14) {
    t15 = <DropdownMenuItem onSelect={t10} className="cursor-pointer px-2 py-1.5 text-sm hover:bg-accent focus:bg-accent data-[highlighted]:bg-accent">{t11}{t13}{t14}</DropdownMenuItem>;
    $[41] = t10;
    $[42] = t13;
    $[43] = t14;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  let t16;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <DropdownMenuSeparator className="bg-border" />;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  let t17;
  if ($[46] !== t) {
    t17 = t("entities.organizations");
    $[46] = t;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  let t18;
  if ($[48] !== t17) {
    t18 = <DropdownMenuLabel className="px-2 py-1.5 text-xs font-semibold text-muted-foreground">{t17}</DropdownMenuLabel>;
    $[48] = t17;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  let t19;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <DropdownMenuSeparator className="bg-border" />;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] !== handleSelectOrganization || $[52] !== organizations || $[53] !== selectedOrganization?.id) {
    let t21;
    if ($[55] !== handleSelectOrganization || $[56] !== selectedOrganization?.id) {
      t21 = org_0 => <DropdownMenuItem key={org_0.id} onSelect={() => handleSelectOrganization(org_0)} className="cursor-pointer px-2 py-1.5 text-sm hover:bg-accent focus:bg-accent data-[highlighted]:bg-accent"><Building2 className="mr-2 h-4 w-4 flex-shrink-0 text-muted-foreground" /><span className="truncate">{org_0.name}</span>{selectedOrganization?.id === org_0.id && <Check className="ml-auto h-4 w-4 flex-shrink-0" />}</DropdownMenuItem>;
      $[55] = handleSelectOrganization;
      $[56] = selectedOrganization?.id;
      $[57] = t21;
    } else {
      t21 = $[57];
    }
    t20 = organizations.map(t21);
    $[51] = handleSelectOrganization;
    $[52] = organizations;
    $[53] = selectedOrganization?.id;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  let t21;
  if ($[58] !== t15 || $[59] !== t18 || $[60] !== t20) {
    t21 = <DropdownMenuContent className="w-60 border-border bg-background text-foreground shadow-xl">{t15}{t16}{t18}{t19}{t20}</DropdownMenuContent>;
    $[58] = t15;
    $[59] = t18;
    $[60] = t20;
    $[61] = t21;
  } else {
    t21 = $[61];
  }
  let t22;
  if ($[62] !== t21 || $[63] !== t9) {
    t22 = <><DropdownMenu>{t9}{t21}</DropdownMenu></>;
    $[62] = t21;
    $[63] = t9;
    $[64] = t22;
  } else {
    t22 = $[64];
  }
  return t22;
}